// Resume44.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

const Resume44 = ({ color = "#00695c" }) => {  // default to first color in your list
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f8f9fa',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '210mm',           // A4
          minHeight: '297mm',
          bgcolor: 'white',
          p: { xs: 5, md: 8 },
          pt: 6,
          pb: 8,
          fontFamily: "'Georgia', 'Times New Roman', serif",
          color: '#1a1a1a',
        }}
      >
        {/* Name & Title */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 900,
              letterSpacing: '3px',
              color: color,              // dynamic
              fontSize: '2.9rem',
              lineHeight: 1.1,
              mb: 1,
            }}
          >
            DREW FEIG
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,              // dynamic
              letterSpacing: '1.5px',
              fontSize: '1.4rem',
              textTransform: 'uppercase',
              mb: 1,
            }}
          >
            MARKETING SPECIALIST
          </Typography>

          <Typography sx={{ fontSize: '1rem', color: '#444', lineHeight: 1.6 }}>
            hello@reallygreatsite.com  |  +123-456-7890  |  123 Anywhere St., Any City, ST 12345
          </Typography>
        </Box>

        <Divider sx={{ borderColor: color, borderWidth: 1, my: 3 }} />

        {/* Profile Summary */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 1.5,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Profile Summary
          </Typography>

          <Typography sx={{ lineHeight: 1.9, fontSize: '0.98rem' }}>
            Highly qualified digital marketing strategist with 7+ years of experience in multiple marketing disciplines, search engine marketing (SEM), and event marketing. Proven ability to drive sales and increase brand awareness for small business clients.
          </Typography>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* Skills – two columns */}
        <Box sx={{ mb: 5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: color,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                flex: 1,
              }}
            >
              Professional Skill
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: color,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                flex: 1,
                textAlign: 'right',
              }}
            >
              Relevant Skill
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 4 }}>
            <Box sx={{ flex: 1 }}>
              <Typography component="ul" sx={{ pl: 3, lineHeight: 2.1, fontSize: '0.97rem' }}>
                <li>Media relation</li>
                <li>Brand management</li>
                <li>Advertising</li>
                <li>Direct Marketing</li>
              </Typography>
            </Box>

            <Box sx={{ flex: 1 }}>
              <Typography component="ul" sx={{ pl: 3, lineHeight: 2.1, fontSize: '0.97rem' }}>
                <li>Supervising</li>
                <li>Newsletter</li>
                <li>Event planning</li>
                <li>Fluent in Spanish</li>
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* Education */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 2,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Education
          </Typography>

          <Box>
            <Typography sx={{ fontWeight: 700, color: '#000' }}>
              Bachelor of Science University
            </Typography>
            <Typography sx={{ color: '#555', fontStyle: 'italic', mb: 0.5 }}>
              Computer Graphics Technology focuses on interactive Multimedia Development
            </Typography>
            <Typography sx={{ color: '#555' }}>
              2009 – 2013
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#888', my: 4 }} />

        {/* Work Experience */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: color,
              mb: 2,
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Work Experience
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
              Marketing Strategist
            </Typography>
            <Typography sx={{ color: '#555', fontStyle: 'italic', mb: 1 }}>
              2021 – 2022
            </Typography>
            <Typography component="ul" sx={{ pl: 3, lineHeight: 2, fontSize: '0.97rem' }}>
              <li>Propel works with clients to create effective and unique marketing strategies to help raise their online profile and support their business objective</li>
            </Typography>
          </Box>

         

        
        </Box>

     

      </Paper>
    </Box>
  );
};

export const resumeMeta = {
  hasPhoto: false,
  columns: 1,
  colorOptions: [
    { value: "#00695c", label: "Deep Teal" },
    { value: "#4caf50", label: "Forest Green" },
    { value: "#ff5722", label: "Deep Orange" },
    { value: "#795548", label: "Warm Brown" },
    { value: "#e61313", label: "Bright Red" }   // removed extra "ff" from your hex
  ]
};

export default Resume44;